<template>
	<mdb-container fluid>
		<mdb-row>
			<mdb-col col="1" md="2"></mdb-col>
			<mdb-col md="8">
        <h1>Health &amp; Safety</h1>
        <p>Foxdown Construction Ltd is fully committed to ensuring the Health, Safety and Welfare of all our employees, subcontractors and those who may come in to contact with our operations.  We retain the services of H & K Safety services who specialise in Health, Safety, Welfare and Environmental issues. They provide advise along with training to complement and reinforce our positive health, safety and environmental culture.​</p>
        <p>Information, along with instruction, is provided to our employees and subcontractors through inductions, toolbox talks, formal training courses and site tours.  This is in addition to a rigorous risk assessment process.  We consult regularly with our employees and subcontractors on all aspects of the business which effect their Health, Safety and Welfare.  Tools and equipment are carefully selected to assist in ensuring the continuing health and wellbeing of our staff.​</p>
        <p>Training is carried out by relevant organisations covering all aspects of our working environment, utilising both CITB &amp; NVQ options, alongside NPORS and many others.  All Contracts Managers and Site Supervisors hold SMSTS, with an internally held NEBOSH qualified Safety Director.  Everyone has a CSCS card.  Records are kept by a training matrix, giving us an effective planning tool to ensure that we maintain and refresh the necessary capabilities of our workforce and allows easy assessment of personnel who would benefit from improvement.​</p>
        <p>Monitoring is carried out internally, complemented by formal safety tours by H &amp; K safety Services around all our worksites.​</p>

        <ul>
          <li>Site Supervisors carry out daily inspections.​</li>
          <li>Contracts Management carry out weekly inspections.​</li>
          <li>H &amp; K carry out formalised safety tours monthly, with an increased frequency when we are deployed as Principal Contractor.​</li>
          <li>Periodic tours by Directors.​</li>
        </ul>

        <p>The information gained from the monthly safety tours is collated into a quarterly KPI analysis, demonstrating trends within the organisation.  This enables training to be targeted at areas which will most benefit.​</p>
        <p>An annual review off all aspects of our Health, Safety and Environmental performance is conducted with our external consultants and this is formalised and reviewed to assist in future planning.​</p>
        <p>We are members of SSIP’s, with SMAS and Builders Profile certification.</p>
			</mdb-col>
			<mdb-col col="1" md="2"></mdb-col>
		</mdb-row>

    <mdb-row>
      <mdb-col col="1" md="2"></mdb-col>
      <mdb-col>
        <mdb-row class="d-inline-flex justify-content-center">
          <img class="mr-4" width="40%" src="@/assets/Safety/helmet.png" alt="Helmet" />
          <img class width="40%" src="@/assets/Safety/high_vis.png" alt="High Vis" />
        </mdb-row>
      </mdb-col>
      <mdb-col col="1" md="2"></mdb-col>
    </mdb-row>

  </mdb-container>

</template>

<script>
import {mdbContainer, mdbRow, mdbCol} from 'mdbvue';
export default {
  name: 'HealthAndSafety',
  components : {
    mdbContainer,
		mdbRow,
		mdbCol
  }
}
</script>
